import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


let socket=null;


export const getSocket = () => socket;
export const connectWebSocket = createAsyncThunk(
  "web/connectToWeb",
  async ({token,increaseNotifyCount,increaseChatNotifyCount}, { dispatch, rejectWithValue }) => {
    try {
       socket = new WebSocket(`${process.env.REACT_APP_WEB_APP_API_URL}/?token=${token}`);
      return await new Promise((resolve) => {
        socket.onopen = () => {
          resolve("connected");
        };
        socket.onmessage = (event) => { 
          
          try {
            const data = JSON.parse(event.data);
            
            if(data.type==='message'){
                dispatch(addWebData(data.data)); // your reducer
            }
            else if(data.type2==='document'){
              toast.info(data.message)
              increaseNotifyCount();
            }else if(data.type2==='chat'){
              toast.info(data.message)
              increaseChatNotifyCount();
            }
          } catch (err) {
            console.log("Invalid WebSocket message", event.data);
          }
        };
        socket.onerror = (error) => {
          console.log("❌ WebSocket error:", error);
          rejectWithValue("WebSocket error");
        };
        socket.onclose = (event) => {
            resolve("disconnected");
        };
      });
    } catch (error) {
      return rejectWithValue("WebSocket connection failed");
    }
  }
);

const webSlice = createSlice({
  name: "web",
  initialState: {
    data: [],
    loading: false,
    error: "",
    connected: false,
  },
  reducers: {
    addWebData: (state, action) => {
        if(Array.isArray(action.payload)){
            state.data = [...action.payload];
        }else{
            state.data.push(action.payload);
        }
    },
    updateMoreData:(state,action)=>{
      state.data = [...action.payload, ...state.data];
    },
    clearWebData: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(connectWebSocket.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.connected = false;
    }).addCase(connectWebSocket.fulfilled,(state)=>{
        state.connected=true;
        state.loading=false;
    }).addCase(connectWebSocket.rejected,(state,action)=>{
        state.loading = false;
        state.error = action.payload || "WebSocket connection error";
        state.connected = false;
    })
  },
});

export const { addWebData, clearWebData,updateMoreData } = webSlice.actions;
export default webSlice.reducer;
